/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-redundant-roles */
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
// @ts-ignore
import { Button } from '@els/els-react--button';
// @ts-ignore
import ErrorLogo from '../../assets/img/Error_Logo.svg';
import Routes from '../../constants/routes';
import { hasSucceeded } from '../../constants/async-status';
import {
    selectAppConfigs,
    selectAppConfigsAsyncStatus,
} from '../../features/app-config/app-config-selector';
import './GeneralErrorPage.scss';

const GeneralErrorPage = () => {
    const baseClassName = 'error-page';
    const redirectToReport = (url: any) => window.open(url, '_blank');
    const history = useHistory();
    const appConfigsAsyncStatus = useSelector(selectAppConfigsAsyncStatus);
    const appConfigs = useSelector(selectAppConfigs);

    const redirectToAssignmentsPage = () => history.push(Routes.WELCOME);
    const SUPPORT_HUB_CONTACT_US_URL =
        hasSucceeded(appConfigsAsyncStatus) &&
        Object.keys(appConfigs).length > 0
            ? appConfigs.SUPPORT_HUB_CONTACT_US_URL
            : '';

    return (
        <div className={baseClassName}>
            <div className={`${baseClassName}-header-row`}>
                <div className={`${baseClassName}-icon`}>
                    <img id={`${baseClassName}-logo`} src={ErrorLogo} />
                </div>
                <div>
                    <div className={`${baseClassName}-message-header`}>
                        <h1 className="page__title" id="header-content">
                            Unfortunately, sign in has failed.
                        </h1>
                        <h2 className={`${baseClassName}_h2_header`}>
                            Return and try again or try resetting your password.
                        </h2>
                        <h3 className={`${baseClassName}_h3_header`}>
                            If you feel this is an error, please report it.
                        </h3>
                    </div>
                    <div className={`${baseClassName}-error-status`}>
                        Error: 401 Authentication required
                    </div>
                    <div className={`${baseClassName}_button_main_div`}>
                        <Button
                            onClick={
                                () =>
                                    redirectToReport(SUPPORT_HUB_CONTACT_US_URL)
                                // eslint-disable-next-line react/jsx-curly-newline
                            }
                            type={Button.Types.PRIMARY}
                            className={`${baseClassName}_action_button_wrapper-success`}
                            id={`${baseClassName}_action_button_wrapper-success`}
                            data-pageindex="0"
                            data-testid="cancel-button"
                        >
                            Report Issue
                        </Button>
                        &nbsp;
                        <Button
                            onClick={redirectToAssignmentsPage}
                            type={Button.Types.SECONDARY}
                            className={`${baseClassName}_action_button_wrapper-cancel`}
                            id={`${baseClassName}_action_button_wrapper-cancel`}
                            data-pageindex="0"
                            data-testid="cancel-button"
                        >
                            Go Back
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GeneralErrorPage;
